import ViewLayout from './ViewLayout.component';

export default ViewLayout;
